import React from 'react'

import { Margin } from '../Margin'

interface DotSeparatorProps {
  spacing?: number
}

// prettier-ignore
export const DotSeparator = ({ spacing = 6 }: DotSeparatorProps) => (
  <Margin left={spacing} right={spacing}>•</Margin>
)
